import React, { useState, useEffect } from 'react';
import axios from 'axios';

const TestRevolutAPI = () => {
    const [loading, setLoading] = useState(false);
    const [counterparties, setCounterparties] = useState([]);
    const [error, setError] = useState(null);
    const [isCreating, setIsCreating] = useState(false);

    

    const fetchCounterparties = async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/revolut/counterparties`,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            setCounterparties(response.data.counterparties);
            console.log('Fetched counterparties:', response.data);
        } catch (err) {
            setError({
                message: err.response?.data?.error?.message || err.message,
                details: err.response?.data
            });
            console.error('API Error:', err.response?.data || err);
        } finally {
            setLoading(false);
        }
    };

    const createCounterparty = async () => {
        setIsCreating(true);
        setError(null);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/revolut/counterparty`,
                {},  // Empty object since data is handled in backend
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            console.log('Created counterparty:', response.data);
            // Refresh the counterparties list
            await fetchCounterparties();
        } catch (err) {
            setError({
                message: err.response?.data?.error?.message || err.message,
                details: err.response?.data
            });
            console.error('API Error:', err.response?.data || err);
        } finally {
            setIsCreating(false);
        }
    };

    // Fetch counterparties when component mounts
    useEffect(() => {
        fetchCounterparties();
    }, []);

    return (
        <div style={{ padding: '20px' }}>
            <h2>Revolut Counterparties</h2>
            
            <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                <button 
                    onClick={fetchCounterparties}
                    disabled={loading || isCreating}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: loading ? '#ccc' : '#007bff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: loading ? 'not-allowed' : 'pointer',
                    }}
                >
                    {loading ? 'Loading...' : 'Refresh Counterparties'}
                </button>

                <button 
                    onClick={createCounterparty}
                    disabled={isCreating || loading}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: isCreating ? '#ccc' : '#28a745',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: isCreating ? 'not-allowed' : 'pointer',
                    }}
                >
                    {isCreating ? 'Creating...' : 'Create Counterparty'}
                </button>
            </div>

            {error && (
                <div style={{ 
                    marginTop: '20px', 
                    padding: '10px', 
                    backgroundColor: '#ffebee',
                    borderRadius: '4px' 
                }}>
                    <h3>Error:</h3>
                    <pre>{JSON.stringify(error, null, 2)}</pre>
                </div>
            )}

            {counterparties.length > 0 ? (
                <div style={{ marginTop: '20px' }}>
                    <h3>Counterparties List:</h3>
                    <div style={{ 
                        display: 'grid', 
                        gap: '10px',
                        maxWidth: '800px' 
                    }}>
                        {counterparties.map((counterparty, index) => (
                            <div 
                                key={counterparty.id || index}
                                style={{
                                    padding: '15px',
                                    backgroundColor: '#f5f5f5',
                                    borderRadius: '4px',
                                    border: '1px solid #ddd'
                                }}
                            >
                                <h4 style={{ margin: '0 0 10px 0' }}>
                                    {counterparty.company_name || counterparty.name}
                                </h4>
                                <div style={{ fontSize: '14px' }}>
                                    <p><strong>ID:</strong> {counterparty.id}</p>
                                    <p><strong>Type:</strong> {counterparty.profile_type}</p>
                                    {counterparty.account_no && (
                                        <p><strong>Account:</strong> {counterparty.account_no}</p>
                                    )}
                                    {counterparty.sort_code && (
                                        <p><strong>Sort Code:</strong> {counterparty.sort_code}</p>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : !loading && (
                <p>No counterparties found.</p>
            )}
        </div>
    );
};

export default TestRevolutAPI; 